<div class="container">
  <mat-sidenav #sidenav mode="side" opened class="sidenav">
    <li>
      <a routerLink="/dashboard" routerLinkActive="active"
        ><span class="material-symbols-outlined icon">travel</span
        ><span>dashboard</span></a
      >
      <a routerLink="/fuel-data" routerLinkActive="active"
        ><span class="material-symbols-outlined icon"> finance </span
        ><span>fuel data</span></a
      >
      <a
        *ngIf="menuItemsVisibility.dataErrors"
        routerLink="/data-errors"
        routerLinkActive="active"
        [matBadge]="unresolvedCount !== 0 ? '&#x21;' : ''"
        ><span class="material-symbols-outlined icon"> error </span
        ><span>data errors</span></a
      >
      <a
        *ngIf="menuItemsVisibility.fuelContracts"
        routerLink="/fuel-contracts" routerLinkActive="active"
        ><span class="material-symbols-outlined icon"> globe </span
        ><span>fuel contracts</span></a
      >
      <a
        *ngIf="menuItemsVisibility.crco"
        routerLink="/crco" routerLinkActive="active"
        ><span class="material-symbols-outlined icon"> qr_code </span
        ><span>CRCO</span></a
      >
      <a
        *ngIf="menuItemsVisibility.sapExport"
        routerLink="/sap-export" routerLinkActive="active"
        ><span class="material-symbols-outlined icon"> upgrade </span
        ><span>sap export</span></a
      >
      <a
        *ngIf="menuItemsVisibility.volumeCalculator"
        routerLink="/volume-calculator" routerLinkActive="active"
        ><span class="material-symbols-outlined icon"> stacks </span
        ><span>volume calculator</span></a
      >
      <a
        *ngIf="menuItemsVisibility.fuelTenders"
        routerLink="/fuel-tenders" routerLinkActive="active"
        ><span class="material-icons icon">content_paste_search</span
        ><span>fuel tenders</span></a
      >
      <a
        *ngIf="menuItemsVisibility.fuelApp"
        routerLink="/fuel-app" routerLinkActive="active"
        ><span class="material-symbols-outlined icon"> smartphone </span
        ><span>fuel app</span></a
      >
      <a
        *ngIf="menuItemsVisibility.dictionary"
        routerLink="/dictionary" routerLinkActive="active"
        ><span class="material-symbols-outlined icon"> dictionary </span
        ><span>dictionary</span></a
      >
      <a
        *ngIf="menuItemsVisibility.reports"
        routerLink="/reports" routerLinkActive="active"
        ><span class="material-symbols-outlined icon"> folder_open </span
        ><span>reports</span></a
      >
    </li>
  </mat-sidenav>
</div>
